import React from "react";

function Home() {
  return (
    <div className="card">
      <h2>Welcome to Quiz Analytics Dashboard</h2>

      <p>
        This app allows you to take quizzes and analyze your performance using interactive charts.
      </p>

      <ul>
        <li>🎮 Take Quiz</li>
        <li>📊 View Results</li>
        <li>📈 Analyze Performance</li>
      </ul>
    </div>
  );
}

export default Home;